import React from 'react';

/**
 * Persistent disclaimer footer for the member portal (HR Hub).
 * Matches the tone of /terms-of-service §6 and /disclaimer so it reads
 * consistent across the site. Understated; small + muted.
 */
export const HRHubFooter = () => {
  return (
    <footer
      className="mt-12 pt-6 pb-8 border-t border-gray-200"
      data-testid="hr-hub-footer"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs text-gray-500 leading-relaxed max-w-2xl mx-auto">
          DriveHR provides HR templates and informational resources, not legal advice.
          Consult a qualified attorney for advice specific to your situation.
        </p>
      </div>
    </footer>
  );
};
